<template>
    <div class="home-box">
        <v-progress-linear v-if="loading" indeterminate color="orange"></v-progress-linear>
        <v-card>
            <v-card-title dark>
                <h3 class="ma-2">Project Reports Club Wise</h3>
                <v-spacer></v-spacer>
                <AutocompleteSearch @changeData="clubId = $event" :storeLink="'member/getRoleClubs'" :setectVale="clubId"
                    :itemText="'name'" :label="'Select Club'" />
                <v-spacer></v-spacer>
                <v-btn @click="loadTaskList()" :disabled="loading || !clubId">Download</v-btn>

            </v-card-title>

        </v-card>

    </div>
</template>

<script>
import MonthsList from "@/utility/months.json";
import { ProjectService } from "@/services/project-service";
import { checkError } from "@/config/errors.js";
import AutocompleteSearch from "@/components/shared/AutocompleteSearch";
import { fileService } from "@/config/file-service.js";

export default {
    name: "ActivityClubWiseReport",
    components: { AutocompleteSearch },

    data: function () {
        return {
            loading: false,
            filterBtnTTip: false,
            month: "",
            months: MonthsList,
            list: [],
            clubId: null,
            role: localStorage.getItem("role"),
            errors: null,
            successMsg: "",
            snackbar: false,           
        };
    },

    mounted() {
        this.$store.dispatch("auth/getProfile");

        localStorage.removeItem("maf_contribution_uuid");
        localStorage.removeItem("mjf_contribution_uuid");
        localStorage.removeItem("service_project_uuid");
        if (this.role == 'CLUB_PRESIDENT' || this.role == 'CLUB_SECRETARY' || this.role == 'CLUB_TREASURER' || this.role == 'CLUB_ADMINISTRATOR') {
            localStorage.removeItem("activity_club");
            this.clubId = localStorage.getItem("club_id");
        }
    },

    watch: {
        clubId(val) {
            if (this.role !== 'CLUB_PRESIDENT' && this.role !== 'CLUB_SECRETARY' && this.role !== 'CLUB_TREASURER' && this.role !== 'CLUB_ADMINISTRATOR') {
                localStorage.setItem("activity_club", val);
            }
        }
    },

    methods: {
        loadTaskList() {
            if (this.clubId) {
                this.loading = true;
                ProjectService.getProjectClubReport(this.clubId, {
                    responseType: "blob",
                })
                    .then((response) => {
                        this.loading = false;
                        if (response.data) {
                            this.list = response.data;
                            this.loading = false;
                            let fileType = response.headers["content-type"];
                            let extension = "csv";
                            fileService.downloadFile(
                                response.data,
                                fileType,
                                extension,
                                "project-" + this.clubId
                            );
                        }
                    })
                    .catch((error) => {
                        this.loading = false;
                        let data = error.response.data;
                        let errorOutput = checkError.errorFormatting(data);
                        this.errors = errorOutput;
                        this.list = [];
                    });
            }

        }


    },
};
</script>
<style>
/* td.rotate {        
height: 400px;
white-space: nowrap;
min-width: 40px;
}

td.rotate-0 {
    min-width: 120px;
}



td.rotate>div {
    transform:
    translate(25px, 51px)       
    rotate(270deg);
    width: 30px;
}

td.rotate>div>span {
    border-bottom: 1px solid #ccc;
    padding: 5px 5px;
    font-size: 11px;
    max-height: 100px;
}

*/
</style>